export class AgentProfile{
    public name;string;
    public emailId:string;
    // public extensionNumber:number;
    // public allowedApplications:Array<any>;
    public skills:Array<any>;
    public lastLoginDate:string;
}